import script from "./NextEventCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NextEventCard.vue?vue&type=script&setup=true&lang=ts"

import "./NextEventCard.vue?vue&type=style&index=0&id=76cc93d3&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76cc93d3"]])

export default __exports__